<!-- Start Signup -->
<div class="login-container">
  <div class="login-wrap">
    <div class="Home-links">
      <a href="index.html"><i class="mdi mdi-home"></i></a>
    </div>
    <div class="form-title" i18n>
      SIGNUP
    </div>
    <form class="login_form">
      <div class="row">
        <div class="col-lg-12">
          <div class="form-group">
            <input name="name" id="name" type="text" class="form-control" placeholder="First Name..." required="">
          </div>
          <div class="form-group">
            <input name="name" id="name" type="text" class="form-control" placeholder="Last Name..." required="">
          </div>
          <div class="form-group">
            <input name="name" id="name" type="email" class="form-control" placeholder="Email..." required="">
          </div>
          <div class="form-group">
            <input name="name" id="name" type="password" class="form-control" placeholder="Password" required="">
          </div>
          <div class="form-group">
            <input name="name" id="name" type="password" class="form-control" placeholder="Confirm Password" required="">
          </div>
          <div class="d-flex justify-content-center">
            <button type="submit" class="btn btn-sm theme-btn text-white text-uppercase login-btn mt-3">Signup</button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 text-center" i18n>
          <p class="text-muted mt-3">Already have an account ?<a href="login.html" class="form-change-link">Login</a></p>
        </div>
      </div>
    </form>
  </div>
</div>
<!-- End Signup -->
